import React, { Suspense, useEffect } from 'react'
import { Routes, Route, useParams } from 'react-router'

import { LazyLoadingMainComponent, LoadingRoute } from '../components/LazyComponent'

import { useSession } from '../providers/SessionProvider'

const Sites = React.lazy(() => import('../containers/Sites'))

const CreateSite = React.lazy(() => import('../containers/CreateSite'))

const NotFound = React.lazy(() => import('../components/templates/NotFound'))

const NotAuthorised = React.lazy(() => import('../containers/NotAuthorised'))

const NewSite = () => {
  const { teamId } = useParams()
  const { setTeam, team, can, error } = useSession()

  useEffect(() => {
    setTeam({ teamId })
  }, [teamId])

  if (error?.type === 'Team')
    return (
      <Suspense fallback={<div />}>
        <NotFound id="team" />
      </Suspense>
    )

  if (team) {
    return (
      <Routes>
        <Route
          index
          element={
            <LazyLoadingMainComponent>
              <Sites />
            </LazyLoadingMainComponent>
          }
        />

        <Route
          path="new"
          element={
            <LazyLoadingMainComponent>
              {can('createSites') ? <CreateSite /> : <NotAuthorised />}
            </LazyLoadingMainComponent>
          }
        />
      </Routes>
    )
  }
  return <LoadingRoute />
}

export default NewSite
